import { useMemo, Fragment } from 'react'

import DefaultValueText from './components/DefaultValueText'
import DefaultValueNumber from './components/DefaultValueNumber'
import DefaultValueSingleSelection from './components/DefaultValueSingleSelection'
import DefaultValueMultipleSelection from './components/DefaultValueMultipleSelection'
import DefaultValueHour from './components/DefaultValueHour'
import DefaultValueDate from './components/DefaultValueDate'
import DefaultValueCPF from './components/DefaultValueCPF'
import DefaultValueCTPS from './components/DefaultValueCTPS'
import DefaultValueCEP from './components/DefaultValueCEP'
import DefaultValuePIS from './components/DefaultValuePIS'
import DefaultValueEmail from './components/DefaultValueEmail'
import DefaultValuePhone from './components/DefaultValuePhone'
import DefaultValueNPS from './components/DefaultValueNPS'
import { DefaultValueCommonProps } from './types/DefaultValueCommonProps'

export default function DefaultValueField({ formMethods, question }: DefaultValueCommonProps) {
  const showNumber = useMemo(() => {
    const kinds = ['INTEGER', 'DECIMAL']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showSingleSelect = useMemo(() => {
    const kinds = ['SINGLE_SELECTION_BOX', 'SINGLE_SELECTION_LIST']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showMultipleSelect = useMemo(() => {
    const kinds = ['MULTIPLE_SELECTION_BOX']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showCPF = useMemo(() => {
    const kinds = ['DOCUMENT']
    const entities = ['CPF']
    return kinds.includes(question.kind as string) && entities.includes(question.entity as string)
  }, [question.kind, question.entity])

  const showCTPS = useMemo(() => {
    const kinds = ['DOCUMENT']
    const entities = ['CTPS']
    return kinds.includes(question.kind as string) && entities.includes(question.entity as string)
  }, [question.kind, question.entity])

  const showPIS = useMemo(() => {
    const kinds = ['DOCUMENT']
    const entities = ['PIS']
    return kinds.includes(question.kind as string) && entities.includes(question.entity as string)
  }, [question.kind, question.entity])

  const showEmail = useMemo(() => {
    const kinds = ['EMAIL']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showPhone = useMemo(() => {
    const kinds = ['PHONE']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showNPS = useMemo(() => {
    const kinds = ['NPS']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showCEP = useMemo(() => {
    const kinds = ['CEP']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showDate = useMemo(() => {
    const kinds = ['DATE']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showHour = useMemo(() => {
    const kinds = ['TIME']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  const showTexts = useMemo(() => {
    const kinds = ['SHORT_TEXT', 'LONG_TEXT']
    return kinds.includes(question.kind as string)
  }, [question.kind])

  return (
    <Fragment>
      {showNumber && <DefaultValueNumber formMethods={formMethods} question={question} />}
      {showSingleSelect && <DefaultValueSingleSelection formMethods={formMethods} question={question} />}
      {showMultipleSelect && <DefaultValueMultipleSelection formMethods={formMethods} question={question} />}
      {showCPF && <DefaultValueCPF formMethods={formMethods} question={question} />}
      {showCTPS && <DefaultValueCTPS formMethods={formMethods} question={question} />}
      {showCEP && <DefaultValueCEP formMethods={formMethods} question={question} />}
      {showPIS && <DefaultValuePIS formMethods={formMethods} question={question} />}
      {showDate && <DefaultValueDate formMethods={formMethods} question={question} />}
      {showHour && <DefaultValueHour formMethods={formMethods} question={question} />}
      {showTexts && <DefaultValueText formMethods={formMethods} question={question} />}
      {showEmail && <DefaultValueEmail formMethods={formMethods} question={question} />}
      {showPhone && <DefaultValuePhone formMethods={formMethods} question={question} />}
      {showNPS && <DefaultValueNPS formMethods={formMethods} question={question} />}
    </Fragment>
  )
}
